import styled from 'styled-components';

export const Container = styled.div`
  .video-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
